import React, { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from "@material-ui/core/styles";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import Translator from "Languages/Utility/Translator";
import MuiAutoComplete from "Components/MuiAutoComplete/MuiAutoComplete";
import { read } from "Helpers/LocalStorage";
import {
  getAllProjectCustomerList,
  updateStateProjectUser,
} from "Stores/actions";
import { useDispatch, useSelector } from "react-redux";
import { useSetState } from "Helpers/Hooks";
import MuiSkeleton from "Components/MuiSkeleton/MuiSkeleton";
import { Alert } from "@material-ui/lab";
import Input from "Components/Input/Input";
import ProjectService from "Services/http/endpoints/project/ProjectService";
import { Chip, DialogActions } from "@material-ui/core";
import ActionFormatter from "Components/Table/ActionFormatter/ActionFormatter";
import { ReactSVG } from "react-svg";
import MuiButton from "Components/MuiButton/MuiButton";
import infoIcon from "Assets/svg/icon/info.svg";
import * as Icons from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";

function StateProjectDialog({ row }) {
  const { t } = useTranslation();
  const { direction } = useTheme();
  const {
    projectsListPagination,
    selectedUser,
    projectDataSearch,
    selectedCustomerAdmin,
  } = useSelector((state) => ({
    projectsListPagination: state.project.projectsListPagination,
    selectedUser: state.project.selectedUser,
    selectedCustomer: state.project.selectedCustomer,
    projectDataSearch: state.project.projectDataSearch,
    selectedCustomerAdmin: state.project.selectedCustomerAdmin,
  }));

  const dispatch = useDispatch();
  const [formValid, setFormValid] = useState({});
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [controls, setControls] = useSetState({
    state: {
      type: "select",
      selectItems: [],
      value: "",
      validation: null,
    },
    description: {
      type: "text",
      value: "",
      validation: null,
      col: 12,
    },
  });

  const handleDialog = () => setOpenDialog(!openDialog);

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));
  };

  const autoCompleteHandler = async (e, value) => {
    const controlName = e.target.id.split("-")[0];
    setControls({ [controlName]: { value: value } });
  };

  const onFinish = async (e) => {
    e.preventDefault();
    const { state, description } = controls;

    try {
      const data = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        Id: row.Id,
        IdState: state.value.value,
        Describ: description.value,
      };
      await dispatch(updateStateProjectUser(data));
      handleDialog();
      const paramsList = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        KeyRequestUser: selectedUser.Key,
        Name: projectDataSearch?.Name,
        IdCustomer: selectedCustomerAdmin.Id,
        IdProject: 0,
        Limit: projectsListPagination.Limit,
        Page: projectsListPagination.Page,
      };
      await dispatch(getAllProjectCustomerList(paramsList));
    } catch (err) {
      console.error('[catch error]', err)
    }
  };

  const onEnter = async () => {
    onClear();
    try {
      setLoading(true);
      const params = {
        KeyUser: read("userKey"),
        KeyGroup: read("groupKey"),
        IdProject: row.Id,
      };
      const response = await ProjectService.getStateProjectList(params);
      const data = response.data.Value;
      const updateData = data.map((dt) => {
        return {
          ...dt,
          label: dt.Name,
          value: dt.Id,
        };
      });
      const selectedState = updateData.filter(
        (item) => item.value === row.IdState
      );
      setControls({
        state: { value: selectedState[0] },
      });
      setControls({ state: { selectItems: updateData } });
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  const onClear = () => {
    setFormValid({});
    setControls({ description: { value: "" } });
  };

  return (
    <>
      <div className="project-status-handler">
        {read("StypeU") !== "2" && (
          <ActionFormatter
            title={<Translator id="ChangeStateProject" />}
            icon={<Icons.Pencil size={14} />}
            className="natural-fill-warning-hover"
            disabled={read("StypeU") === "2"}
            onClick={handleDialog}
          />
        )}
        <span>{row.NameState}</span>
      </div>
      <Dialog
        dir={direction}
        open={openDialog}
        onClose={handleDialog}
        onEnter={onEnter}
        fullWidth
        maxWidth="sm"
      >
        <form onSubmit={onFinish}>
          <div className="dialogHeader">
            <p>
              {<Translator id="determineStatusProject" />} : {row.Name}{" "}
            </p>
          </div>
          <DialogContent style={{ overflow: "visible" }}>
            {!loading ? (
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Alert
                    severity="info"
                    variant="outlined"
                    icon={<ReactSVG src={infoIcon} />}
                  >
                    {`${t('state')}:`}
                    {row.NameState}
                  </Alert>
                </Grid>
                {Object.keys(controls).map((key, index) => {
                  return (
                    <Grid item sm={6} xs={12} key={key + index}>
                      {controls[key].type === "select" && (
                        <MuiAutoComplete
                          autoSelect={true}
                          loading={loading}
                          options={controls[key].selectItems}
                          label={<Translator id={key} />}
                          value={controls[key].value}
                          id={key}
                          onChange={autoCompleteHandler}
                        />
                      )}
                      {controls[key].type === "text" && (
                        <Input
                          setValue={setValue.bind(this)}
                          name={key}
                          validation={controls[key].validation}
                          label={<Translator id={key} />}
                          type="text"
                          value={controls[key].value}
                        />
                      )}
                    </Grid>
                  );
                })}
              </Grid>
            ) : (
              <MuiSkeleton xs={6} number={2} />
            )}
          </DialogContent>
          <DialogActions>
            <MuiButton
              color="primary"
              type="submit"
              title={<Translator id="button_save" />}
            />
            <MuiButton
              onClick={handleDialog}
              title={<Translator id="enseraf" />}
            />
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}

export default StateProjectDialog;
